import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { QuickComment, StationAudit, orderStationAudit } from '../../../../models/check-interface';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { TOAST_STATE, ToastService } from '../../../../services/toast.service';
import { CheckStorageService } from '../../../../services/check-storage.service';
import { ChangeDetectorRef } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { Router } from '@angular/router';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';

@Component({
  selector: 'lib-gallery-station-audit-tab',
  templateUrl: './gallery-station-audit-tab.component.html',
  styleUrls: ['./gallery-station-audit-tab.component.scss']
})
export class GalleryStationAuditTabComponent implements OnInit, OnChanges {

  @Input() stationAudits: StationAudit[] = [];
  @Input() checkId!: string;
  @Input() isFirstSAMessageShown!: boolean;
  @Input() quickComments!: QuickComment[];
  @Input() editable!: boolean;

  @Output() updateImageEvent = new EventEmitter();
  @Output() emitClickTextarea: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() emitClearInterval: EventEmitter<boolean> = new EventEmitter<boolean>();

  public openCollapseGallery = false;
  public selectedImage = '';
  public selectedId: string = '';
  public stationAuditSelected!: any;
  public originalImage: string = '';
  public itemPosSelected: number = 0;

  @ViewChild('galleryList') galleryList: ElementRef;
  @ViewChild('addStationButton') addStationButton: ElementRef;
  items: Array<StationAudit> = [];
  itemsTable!: Array<StationAudit[]>;
  boxWidth = 48;
  columnSize!: number;
  isExpanded: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private checkStorageService: CheckStorageService,
    private toastService: ToastService,
    private alertCtrl: AlertController,
    private cdr: ChangeDetectorRef,
    private config: AppConfig,
    public layoutService: PHBHPLayoutPackageService,
    private router: Router,
  ) { }

  public mode!: 'edit' | 'view';
  ngOnInit(): void {
    if (this.router.url.includes('view')) {
      this.mode = 'view';
    } else {
      this.mode = 'edit';
    }

    if (this.stationAudits.length > 0) {
      this.getImages();
    }
  }

  async addNewStationAudit(): Promise<void> {}

  async takePicture(evt: Event) {}

  getImages() {
    const updateImages = new Promise<void>((resolve, reject) => {
      this.stationAudits.forEach((stationAudit, index) => {
      this.layoutService.showLoader = true;
      if (this.mode === 'view') {
          this.checkStorageService.getStationAuditPhotos(stationAudit.id).subscribe((resp: any) => {
            if (resp && resp.length > 0) {
              // Get the last image uploaded, defined by createOn date, so we can get the last image uploaded
              resp.sort((a: any, b: any) => new Date(b.createOn).getTime() - new Date(a.createOn).getTime());
              if (this.checkStorageService.verifyNetworkStatus()) {
                stationAudit.imageCircleData = resp[0].url;
              } else {
                stationAudit.imageCircleData = resp[0].data;
              }
              if (index === this.itemPosSelected) {
                this.changeImage(stationAudit);
              }
              if (!this.itemPosSelected) {
                this.changeImage(this.stationAudits[0]);
              }
            }
          });

          this.checkStorageService.getStationAuditPhotos(stationAudit.id, 1).subscribe((resp: any) => {
            if (resp && resp.length > 0) {
              const id = resp[0].folder.split('/')[2];
              if (id === stationAudit.id) {
                if (this.checkStorageService.verifyNetworkStatus()) {
                  stationAudit.imageData = resp[0].url;
                } else {
                  stationAudit.imageData = resp[0].data;
                }
                // si se quita esto no funciona en online
                if (index === this.itemPosSelected) {
                  this.changeImage(stationAudit);
                }
                if (!this.itemPosSelected) {
                  this.changeImage(this.stationAudits[0]);
                }
              }
            }
          });
        }
      });

      resolve();
    });

    updateImages.then(() => {
      this.items = this.stationAudits;
      this.columnSize;
      this.getItemsTable(true);
      this.layoutService.showLoader = false;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['stationAudits'] && changes['stationAudits'].currentValue) {
      var previousStationAudits = changes['stationAudits'].previousValue ? changes['stationAudits'].previousValue.length : 0;
      this.stationAudits = changes['stationAudits'].currentValue;
      var currentStationAudits = changes['stationAudits'].currentValue ? changes['stationAudits'].currentValue.length : 0;
      if (this.stationAudits.length > 0) {
        this.getImages();
      }

      if (previousStationAudits < currentStationAudits) {
        this.changeImage(this.stationAudits[this.stationAudits.length - 1]);
      }
      this.getItemsTable(true);
      this.cdr.detectChanges();
      this.scrollToBottom(true);
    }
  }

  getItemsTable(load?: boolean): any[][] {
    if (this.stationAudits.length == 0) return [];

    this.items = this.stationAudits.slice(0, this.stationAudits.length >= 6 && !this.openCollapseGallery ? 5 : this.stationAudits.length);

    if (this.columnSize === undefined || load) {
      this.columnSize = 6;
      this.initTable();
    }
    return this.itemsTable;
  }

  initTable(reorder?: boolean) {

    const auxNull: StationAudit = {
      id: '',
      checkID: '',
      roomNumber: '',
      comment: '',
      imageData: '',
      creationDate: new Date(),
      modificationDate: new Date(),
      updatedBy: this.config.userData.userId,
      auditQuickComments: [],
      orderNumber: 0,
      x: null,
      y: null,
      circleColor: '',
      imageCircleData: '',
      sync: 0,
      withPicture: true, // TODO
      isDeleted: false
    }

    if (reorder) {
      const addBtnPos = this.items.findIndex(item => item.id === 'btn-add');
      // move add button to the end of the list
      this.items.push(this.items.splice(addBtnPos, 1)[0]);
      const provisional = this.items.filter(item => item.id !== '');
      for (let i = provisional.length; i < this.items.length; i++) {
        provisional.push(auxNull);
      }
      this.items = provisional;
    }

    // create table rows based on input list
    this.itemsTable = this.items.slice(0, !this.openCollapseGallery ? 5 : this.items.length)
      .filter((_, outerIndex) => (outerIndex % this.columnSize == 0)) // create outter list of rows
      .map((
        _,
        rowIndex // fill each row from...
      ) =>
        this.items.slice(
          rowIndex * this.columnSize, // ... row start and
          rowIndex * this.columnSize + this.columnSize // ...row end
        )
      );

    const elementsLastRow = this.itemsTable[this.itemsTable.length - 1].length;
    const auxAddBtn: StationAudit = {
      id: 'btn-add',
      checkID: 'btn',
      roomNumber: 'btn',
      comment: 'btn',
      imageData: 'btn',
      creationDate: new Date(),
      modificationDate: new Date(),
      updatedBy: this.config.userData.userId,
      auditQuickComments: [],
      orderNumber: 0,
      x: null,
      y: null,
      circleColor: '',
      imageCircleData: '',
      sync: 0,
      withPicture: true, // TODO
      isDeleted: false
    }

    if (elementsLastRow < 6 && !reorder) {
      const elementsToAdd = 6 - elementsLastRow;
      this.itemsTable[this.itemsTable.length - 1].push(auxAddBtn);
      for (let i = 0; i < elementsToAdd - 1; i++) {
        this.itemsTable[this.itemsTable.length - 1].push(auxNull);
      }
    }
    if (elementsLastRow === 6 && !reorder) {
      this.itemsTable.push([auxAddBtn, auxNull, auxNull, auxNull, auxNull, auxNull]);
    }
  }

  reorderDroppedItem(event: CdkDragDrop<any[]>) {
    // same row/container? => move item in same row
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      // different rows? => transfer item from one to another list
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }

    // update items after drop: flatten matrix into list
    // example: [ [1,2,3], [4,5,6] ] => [1,2,3,4,5,6]
    this.items = this.itemsTable.reduce(
      (previous, current) => previous.concat(current),
      []
    );

    const itemsToReorder: orderStationAudit[] = [];

    this.items.forEach((item: StationAudit, index) => {
      item.orderNumber = index + 1;
      if (item.id !== 'btn-add' && item.id !== '') {
        itemsToReorder.push({
          stationAuditId: item.id,
          orderNumber: item.orderNumber
        });
      }
    });

    this.checkStorageService.putOrderStationAudits(itemsToReorder).subscribe();

    // re-initialize table - makes sure each row has same numbers of entries
    // example: [ [1,2], [3,4,5,6] ] => [ [1,2,3], [4,5,6] ]
    this.initTable(true);
  }

  updatePosition(stationAudit: StationAudit) {
    if (stationAudit.id === 'empty-station-audit') {
      this.checkStorageService.postStationAudit(true, stationAudit).subscribe((resStationAudit: any) => {
        if (!resStationAudit) {
          this.toastService.showToast(TOAST_STATE.danger, 'Fehler!', 'Ein Fehler ist aufgetreten');
        }

        this.selectedId = resStationAudit.id;
        this.stationAudits[0] = resStationAudit;
        this.refreshStationAuditsList();
        this.changeImage(this.stationAudits[this.stationAudits.length - 1]);
      });
    } else {
      this.checkStorageService.putStationAudit(stationAudit.id, stationAudit).subscribe(() => { });
    }
  }

  changeImage(item: any) {
    this.selectedId = item.id;
    this.selectedImage = item.circleColor ? ((item.imageData && item.x !== null && item.y !== null) ? item.imageData : item.imageCircleData) : '';
    this.originalImage = item.imageCircleData;
    this.stationAuditSelected = this.stationAudits.find(stationAudit => stationAudit.id === item.id);
    this.itemPosSelected = this.stationAudits.findIndex(stationAudit => stationAudit.id === item.id);
  }

  viewAllElements() {
    this.openCollapseGallery = !this.openCollapseGallery;

    if (this.openCollapseGallery) {
      this.items = this.stationAudits;
    } else {
      this.items = this.stationAudits.slice(0, 5);
    }
    this.initTable();
  }

  // Vertical gallery
  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.stationAudits, event.previousIndex, event.currentIndex);
    const itemsToReorder: orderStationAudit[] = [];

    this.stationAudits.forEach((item: StationAudit, index) => {
      item.orderNumber = index + 1;
      if (item.id !== 'btn-add' && item.id !== '') {
        itemsToReorder.push({
          stationAuditId: item.id,
          orderNumber: item.orderNumber
        });
      }
    });

    this.checkStorageService.putOrderStationAudits(itemsToReorder).subscribe();

    // re-initialize table - makes sure each row has same numbers of entries
    // example: [ [1,2], [3,4,5,6] ] => [ [1,2,3], [4,5,6] ]
    this.initTable(true);
  }

  isStationDeleteDisabled(): boolean {
    return this.selectedId === 'empty-station-audit';
  }

  async deleteStationAudit(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.isStationDeleteDisabled()) {
      return;
    }

    const alert = await this.alertCtrl.create({
      header: this.layoutService.translateText('CHECK.DELETE_AUDIT_TITLE'),
      message: this.layoutService.translateText('CHECK.DELETE_AUDIT_MESSAGE'),
      cssClass: 'confirmation-popup info-alerts-observe-page',
      backdropDismiss: false,
      buttons: [
        {
          text: this.layoutService.translateText('AUTHORIZATION.CANCEL'),
          role: 'cancel',
          cssClass: 'alert-done-button-no',
        },
        {
          text: this.layoutService.translateText('LAYOUT_MODULE.DELETE'),
          cssClass: 'alert-done-button-yes',
          handler: () => {
            this.checkStorageService.deleteStationAudit(true, this.selectedId).subscribe({
              next: () => {
                const index = this.stationAudits.findIndex(audit => audit.id === this.selectedId);
                if (index > -1) {
                  this.stationAudits.splice(index, 1);
                  this.stationAudits = [...this.stationAudits];
                }
                var newIndex = index - 1 >= 0 ? index - 1 : 0;
                if (this.stationAudits.length > 0) {
                  this.changeImage(this.stationAudits[newIndex]);
                } else {
                  this.stationAudits = [{
                    checkID: this.checkId,
                    imageData: "",
                    roomNumber: "",
                    comment: "",
                    auditQuickComments: [],
                    id: 'empty-station-audit',
                    creationDate: new Date(),
                    modificationDate: new Date(),
                    updatedBy: this.config.userData.userId,
                    orderNumber: 1,
                    imageCircleData: '',
                    x: null,
                    y: null,
                    circleColor: '',
                    sync: 0,
                    withPicture: true,
                    isDeleted: true
                  }];

                  this.changeImage(this.stationAudits[0]);
                }

                this.setFullscreenOpen(false);
                this.getItemsTable(true);
                this.cdr.detectChanges();
              },
              error: (err) => {
                console.error(err);
              }
            });
          }
        }
      ]
    });

    await alert.present();
  }


  isFullscreenModalOpen: boolean = false;
  isEditImageModalOpen: boolean = false;

  setFullscreenOpen(isOpen: boolean, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.toggleBodyPageOverflow(isOpen);
    this.isFullscreenModalOpen = isOpen;
  }

  getItemsTableVertical() {
    return this.stationAudits;
  }

  async openEditModal(event: Event) {}

  private toggleBodyPageOverflow(enable: boolean) {
    const bodyPageElement = document.querySelector('.body-page') as HTMLElement;
    if (bodyPageElement) {
      bodyPageElement.style.overflowY = enable ? 'initial' : 'scroll';
    }
  }

  public onPictureChange(stationAudit: StationAudit, event: Event): void {
    this.emitClearInterval.emit(true);
    stationAudit.withPicture = !stationAudit.withPicture;
    if (stationAudit.id === 'empty-station-audit') {
      this.checkStorageService.postStationAudit(true, stationAudit).subscribe((resStationAudit: any) => {
        if (!resStationAudit) {
          this.toastService.showToast(TOAST_STATE.danger, 'Fehler!', 'Ein Fehler ist aufgetreten');
        }

        this.selectedId = resStationAudit.id;
        this.stationAudits.push(resStationAudit);
        this.refreshStationAuditsList();
        this.changeImage(this.stationAudits[this.stationAudits.length - 1]);
        this.cdr.detectChanges();
      });
    } else {
      this.checkStorageService.putStationAudit(stationAudit.id, stationAudit).subscribe(() => {
        this.cdr.detectChanges();
      });
    }
  }

  public onViewPictureChange(stationAudit): void {
    this.emitClearInterval.emit(true);
    this.changeImage(stationAudit);
  }

  public getGalleryImage(stationAudit: StationAudit): string {
    if (stationAudit.withPicture) {
      if (stationAudit.imageCircleData != '' && stationAudit.imageCircleData != null && stationAudit.imageCircleData != "data:image/jpeg;base64,") {
        return stationAudit.imageCircleData;
      } else {
        return 'assets/icons/missing-image.svg';
      }
    } else {
      return 'assets/icons/audit-no-image.svg';
    }
  }

  public getGalleryImageUrl(stationAudit: StationAudit): string {
    if (stationAudit.withPicture) {
      if (stationAudit.imageCircleData != '' && stationAudit.imageCircleData != null && stationAudit.imageCircleData != "data:image/jpeg;base64,") {
        return `url('${stationAudit.imageCircleData}')`;
      } else {
        return `url('assets/icons/missing-image.svg')`;
      }
    } else {
      return `url('assets/icons/audit-no-image.svg')`;
    }
  }

  scrollToBottom(isFirstLoad: boolean = false): void {
    try {
      if (this.isTablet() || isFirstLoad) {
        this.galleryList.nativeElement.scrollTop = this.galleryList.nativeElement.scrollHeight;
      } else {
        this.addStationButton.nativeElement.scrollIntoView({ block: 'end', inline: 'nearest' });
      }
    } catch (err) {
      console.error('Error scrolling to bottom:', err);
    }
  }

  public showNoPhotoAvailable(): boolean {
    return (!this.originalImage && !this.selectedImage && (this.stationAuditSelected && this.stationAuditSelected.withPicture)) || (this.stationAuditSelected && this.stationAuditSelected.withPicture && this.stationAuditSelected.imageCircleData && this.stationAuditSelected.imageCircleData === "data:image/jpeg;base64,");
  }

  public emitCreateStationAudit(stationAudit: any): void {
    this.stationAudits.push(stationAudit);
    this.refreshStationAuditsList();
    this.changeImage(this.stationAudits[this.stationAudits.length - 1]);
  }

  public emitUpdateStationAudit(stationAudit: StationAudit): void {
    var index = this.stationAudits.findIndex(audit => audit.id === stationAudit.id);
    this.stationAudits[index] = stationAudit;
  }

  public retakeImage(evt: Event): void {
    evt.preventDefault();
    evt.stopPropagation();
    this.takePicture(evt);
  }

  public isTablet(): boolean {
    return window.innerWidth > 768;
  }

  public isLandscapeTablet(): boolean {
    return window.innerWidth > 1024;
  }

  refreshStationAuditsList() {
    this.updateImageEvent.emit();
    this.getItemsTable(true);
    this.cdr.detectChanges();
    this.scrollToBottom();
    this.layoutService.showLoader = false;
  }
}
